import { createFileRoute } from '@tanstack/react-router';
import Basics from 'src/pages/Organization/Event/Basics';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/basics',
)({
  component: Basics,
});
